import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ArrowRight } from 'lucide-react';

gsap.registerPlugin(ScrollTrigger);

const PricingTeaser = () => {
    const containerRef = useRef(null);

    useEffect(() => {
        const ctx = gsap.context(() => {
            gsap.from('.teaser-element', {
                y: 40,
                opacity: 0,
                duration: 1,
                stagger: 0.1,
                ease: 'power3.out',
                scrollTrigger: {
                    trigger: containerRef.current,
                    start: 'top 75%',
                },
            });
        }, containerRef);
        return () => ctx.revert();
    }, []);

    return (
        <section
            id="reserve"
            ref={containerRef}
            className="py-24 md:py-32 bg-[#0A0A14] relative border-t border-[#7B61FF]/20 z-40"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-16">
                <div className="teaser-element text-center mb-12">
                    <span className="font-data text-[#7B61FF] text-xs font-bold tracking-widest uppercase mb-6 block">
                        Two Ways In
                    </span>
                    <h2 className="text-[#F0EFF4] font-bold text-4xl md:text-5xl tracking-tight mb-4">
                        Ready today, or{' '}
                        <span className="font-drama text-[#7B61FF]">not sure yet?</span>
                    </h2>
                    <p className="text-[#F0EFF4]/60 text-lg max-w-2xl mx-auto">
                        Your AI employee is waiting. The only question is how ready you are to meet them.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto">
                    <div className="teaser-element rounded-[2rem] p-8 bg-[#18181B] border border-[#7B61FF]/40 shadow-[0_0_30px_rgba(123,97,255,0.12)] flex flex-col">
                        <span className="self-start font-data text-[10px] tracking-widest uppercase px-3 py-1 rounded-full bg-[#7B61FF] text-[#F0EFF4]">
                            Ready to Go
                        </span>
                        <p className="font-drama text-[#F0EFF4] text-5xl mt-5 mb-2 leading-none">$10,000</p>
                        <p className="text-[#F0EFF4]/60 text-sm mb-6">
                            Full RoofClaw build, hardware in hand, agent running.
                        </p>
                        <Link
                            to="/pricing"
                            className="btn-magnetic mt-auto w-full flex items-center justify-center gap-3 px-6 py-4 rounded-full font-semibold text-base bg-[#7B61FF] text-[#F0EFF4] shadow-[0_0_20px_rgba(123,97,255,0.4)] hover:shadow-[0_0_40px_rgba(123,97,255,0.65)] transition-all"
                        >
                            See Build Details <ArrowRight size={18} />
                        </Link>
                    </div>

                    <div className="teaser-element rounded-[2rem] p-8 bg-[#18181B] border border-[#F0EFF4]/10 flex flex-col">
                        <span className="self-start font-data text-[10px] tracking-widest uppercase px-3 py-1 rounded-full bg-[#18181B] border border-[#F0EFF4]/20 text-[#F0EFF4]">
                            Not Sure Yet
                        </span>
                        <p className="font-drama text-[#F0EFF4] text-5xl mt-5 mb-2 leading-none">$800</p>
                        <p className="text-[#F0EFF4]/60 text-sm mb-6">
                            AI Readiness Session. One hour with Adam. Roadmap yours to keep.
                        </p>
                        <Link
                            to="/readiness"
                            className="btn-magnetic mt-auto w-full flex items-center justify-center gap-3 px-6 py-4 rounded-full font-semibold text-base border border-[#F0EFF4]/30 text-[#F0EFF4] hover:bg-[#F0EFF4]/5 transition-all"
                        >
                            Book a Readiness Session <ArrowRight size={18} />
                        </Link>
                    </div>
                </div>

                <div className="teaser-element text-center mt-10">
                    <Link
                        to="/pricing"
                        className="inline-flex items-center gap-2 text-[#F0EFF4]/60 hover:text-[#7B61FF] text-sm transition-colors"
                    >
                        See full pricing, FAQs, and what's included →
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default PricingTeaser;
